import React, { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import diuLogo from "../../assets/diu-logo.png";

const Header = ({ onNavigate, currentPage, onHome }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: "Home", page: "home" },
    { name: "Explorer", page: "explorer" },
    { name: "Cross Analysis", page: "cross" },
    { name: "AI", page: "reports" },
    { name: "About", page: "about" },
  ];

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* TRAC Title - Left Side */}
          <div className="flex-1 flex justify-start min-w-0">
            <div
              className="flex items-center gap-3 cursor-pointer group"
              onClick={() => onHome && onHome()}
              title="Go to Home"
            >
              <div className="flex flex-col">
                <h1 className="text-xl font-bold text-gray-900 tracking-tight leading-none group-hover:text-trac-600 transition-colors">
                  TRAC
                </h1>
                <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                  The Rural Analytic Centre
                </p>
              </div>
            </div>
          </div>

          {/* Desktop Navigation - Center */}
          <nav className="hidden md:flex items-center gap-2">
            {navigation.map((item) => {
              const active = currentPage === item.page;
              return (
                <button
                  key={item.name}
                  onClick={() => onNavigate && onNavigate(item.page)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    active
                      ? "bg-trac-50 text-trac-700 shadow-sm ring-1 ring-trac-200"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                >
                  {item.name}
                </button>
              );
            })}
          </nav>

          {/* DIU Logo & Mobile Menu - Right Side */}
          <div className="flex-1 flex justify-end items-center gap-4 min-w-0">
            <div className="hidden md:block flex-shrink-0">
              <img
                src={diuLogo}
                alt="DIU"
                className="h-8 w-auto object-contain"
              />
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-trac-500"
              >
                <span className="sr-only">Open main menu</span>
                {isMenuOpen ? (
                  <XMarkIcon className="h-6 w-6" />
                ) : (
                  <Bars3Icon className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 absolute w-full left-0 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {navigation.map((item) => {
              const active = currentPage === item.page;
              return (
                <button
                  key={item.name}
                  onClick={() => {
                    onNavigate && onNavigate(item.page);
                    setIsMenuOpen(false);
                  }}
                  className={`${
                    active
                      ? "bg-trac-50 text-trac-700"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  } w-full text-left px-4 py-3 text-base font-medium rounded-lg transition-colors`}
                >
                  {item.name}
                </button>
              );
            })}
            {/* Mobile specific logo view */}
            <div className="pt-4 mt-2 border-t border-gray-100 flex justify-center pb-2">
              <img src={diuLogo} alt="DIU" className="h-8 w-auto opacity-80" />
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
